export const formatIsoDate = (year, month, day) =>
  `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

export function getWorkingDays(year, month, holidays = []) {
  const holidayDates = new Set(Array.from(holidays, item => typeof item === 'string' ? item : item?.date).filter(Boolean));
  const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();

  return Array.from({ length: daysInMonth }, (_, index) => index + 1).filter(day => {
    const date = formatIsoDate(year, month, day);
    const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return weekday !== 0 && !holidayDates.has(date);
  });
}

export function isWorkingDate(date, holidays = []) {
  const match = String(date || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (formatIsoDate(year, month, day) !== date) return false;
  return getWorkingDays(year, month, holidays).includes(day);
}

export function getWorkingRows(rows, workingDays) {
  const allowedDays = new Set(workingDays);
  return rows.filter(row => allowedDays.has(Number(String(row.date || '').slice(-2))));
}
